import {fieldConditionHelper} from "@/form/helpers/field-conditionals.js";
import {rentMortgagePaymentStep} from "@/form/helpers/field-choices.js";

let steps = [
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        // topTitle: function(app) {
        //     if(app) {
        //         if(app.hasOwnProperty('experiments')) {
        //             const exp3 = app.experiments['exp3'] ?? null;
        //             switch (exp3) {
        //                 case 'exp3__varB':
        //                     return null;
        //                 case 'exp3__varA':
        //                 case 'exp3__varC':
        //                 default:
        //                     return `<h3 class="mb-3 text-center h2">__lets_get_you_approved__</h3>`;
        //             }
        //         }
        //     }
        //     return `<h3 class="mb-3 text-center h2">__lets_get_you_approved__</h3>`;
        // },
        title: "__what_are_you_looking_for__",
        fields: [
            {
                // label: 'Loan Purpose',
                name: 'new_asset_name',
                placeholder: '__select__',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    {"text": "__opt_powersports_rv__", "value": "rv"},
                    {"text": "__opt_powersports_boat__", "value": "boat"},
                    {"text": "__opt_powersports_tractor__", "value": "tractor"},
                    {"text": "__opt_powersports_atv__", "value": "atv"},
                    {"text": "__opt_powersports_motorcycle__", "value": "motorcycle"},
                    {"text": "__opt_powersports_snowmobile__", "value": "snowmobile"},
                    {"text": "__opt_powersports_ebike__", "value": "e-bike"},
                    {"text": "__opt_powersports_camper__", "value": "camper"},
                    // {"text": "__opt_powersports_heavyequipment__", "value": "heavy-equipment"},
                    {"text": "__opt_powersports_personalwatercraft__", "value": "personal-watercraft"},
                ],
                hideIfHasValue: true,
            },
        ],
        // textBottom: `
        // <p class="text-muted text-center" style="font-size:14px;">
        //     Please note there is no cost or obligation after you submit your application.
        //     If you wish, you can change your choice of car at a later time.
        // </p>`,
        hideButtonsSection: true,
        // isStepReadOnly: true,
        // isStepEditable: true,
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__requested_amount_powersports__",
        fields: [
            {
                // label: 'Desired Loan Amount',
                name: 'requested_amount',
                placeholder: '1000',
                // prependInputSpan: '$',
                // appendInputSpan: '.00',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    {"text": "__opt_1001_5000__", "value": "3500"},
                    {"text": "__opt_5001_10000__", "value": "7500"},
                    {"text": "__opt_10001_15000__", "value": "15000"},
                    {"text": "__opt_15001_20000__", "value": "20000"},
                    {"text": "__opt_20001_50000__", "value": "35000"},
                    {"text": "__opt_50000_more__", "value": "50000"},
                ],
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
        // isStepReadOnly: true,
        // isStepEditable: true,
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__car_in_credit_situation__",
        fields: [
            {
                // label: 'Loan Purpose',
                name: 'in_credit_situation',
                placeholder: '__select__',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    // {"text": "__opt_1000_less__", "value": "750"},
                    {"text": "__opt_in_credit_situation_good__", "value": "good"},
                    {"text": "__opt_in_credit_situation_fair__", "value": "fair"},
                    {"text": "__opt_in_credit_situation_low__", "value": "low"},
                    {"text":"__opt_in_credit_situation_bk__", "value":"in_bankruptcy"},
                    {"text": "__opt_in_credit_situation_unknown__", "value": "unknown"},
                ],
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
        // isStepReadOnly: true,
        // isStepEditable: true,
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__income_type__",
        fields: [
            {
                // label: 'Income Source',
                name: 'income_type',
                placeholder: '__income_type__',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    { "text":"__opt_income_type_full__", "value":"full_time" },
                    { "text":"__opt_income_type_part__", "value":"part_time" },
                    { "text":"__opt_income_type_self__", "value":"self_employed" },
                    { "text":"__opt_income_type_pension__", "value":"retired" },
                    { "text":"__opt_income_type_other__", "value":"other" },
                ],
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__income_type_other__",
        fields: [
            {
                // label: 'Income Source',
                name: 'income_type_other',
                placeholder: '__income_type_other__',
                type: 'checkbox',
                value: null,
                validationRules: 'required',
                // fieldInnerClass: 'large-checkbox',
                isMultipleOption: true,
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    { "text":"__opt_income_type_other_wsib__", "value":"wsib" },
                    { "text":"__opt_income_type_other_short_term_disability__", "value":"short_term_disability" },
                    { "text":"__opt_income_type_other_long_term_disability__", "value":"long_term_disability" },
                    { "text":"__opt_income_type_other_social_security__", "value":"social_security" },
                    { "text":"__opt_income_type_other_child_tax_benefit__", "value":"child_tax_benefit" },
                    { "text":"__opt_income_type_other_rental_income__", "value":"rental_income" },
                    { "text":"__opt_income_type_other_other__", "value":"other" },
                    { "text":"__opt_income_type_other_none__", "value":"none" },
                ],
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: false,
        hideIfCondition: (app) => {
            // if(!app.hasOwnProperty('income_type') || app.income_type != 'other') {
            //     return true;
            // }
            // return false;
        }
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__monthly_income_input__",
        fields: [
            {
                // label: 'Monthly Income',
                label: (app) => {
                    let labelMessage = '__monthly_income__';
                    if(app && app.income_type && ['full_time', 'part_time', 'self_employed'].includes(app.income_type)) {
                        labelMessage = '__monthly_income_employment__';
                    }
                    else if(app && app.income_type && app.income_type == 'retired') {
                        labelMessage = '__monthly_income_pension__';
                    }
                    return labelMessage;
                },
                name: 'monthly_income',
                placeholder: '2500',
                prependInputSpan: '$',
                appendInputSpan: '.00',
                type: 'text',
                value: null,
                validationRules: 'required|numeric',
                fieldOuterClass: 'col-md-8 offset-md-2',
                hideIfHasValue: false,
                attrs: {
                    maxlength: 5
                },
                hideIfCondition: (app) => {
                    return app && app.income_type && app.income_type == 'other';
                }
            },
            {
                // label: 'Other Monthly Income',
                label: '__monthly_other_income__',
                name: 'monthly_other_income',
                placeholder: '2500',
                prependInputSpan: '$',
                appendInputSpan: '.00',
                type: 'text',
                value: null,
                validationRules: 'required|numeric',
                fieldOuterClass: 'col-md-8 offset-md-2',
                hideIfHasValue: false,
                attrs: {
                    maxlength: 5
                },
                hideIfCondition: (app) => {
                    let invalidOtherIncomeTypes = ['none', 'other'];
                    let selectedOtherIncomeTypes = app.income_type_other ?? [];
                    // we hide this input if income_type_other selected option is just 'none' or 'other'
                    if(selectedOtherIncomeTypes.length == 1 && invalidOtherIncomeTypes.includes(selectedOtherIncomeTypes[0])) {
                        return true;
                    }
                    return false;
                }
            },
        ],
        hideButtonsSection: false,
        hideIfCondition: (app) => {
            let invalidOtherIncomeTypes = ['none', 'other'];
            let selectedOtherIncomeTypes = app.income_type_other ?? [];
            let selectedIncomeType = app.income_type ?? null;
            // we hide this step if both fields were hidden
            if(selectedIncomeType == 'other' && selectedOtherIncomeTypes.length == 1 && invalidOtherIncomeTypes.includes(selectedOtherIncomeTypes[0])) {
                return true;
            }
            return false;
        }
    },
    // {
    //     beforeCreate: function() {},
    //     beforeNextStep: function() {},
    //     title: "__monthly_income_input__",
    //     fields: [
    //         {
    //             // label: 'Monthly Income',
    //             name: 'monthly_other_income',
    //             placeholder: '2500',
    //             prependInputSpan: '$',
    //             appendInputSpan: '.00',
    //             type: 'text',
    //             value: null,
    //             validationRules: 'required|numeric',
    //             fieldOuterClass: 'col-md-8 offset-md-2',
    //             hideIfHasValue: true,
    //             attrs: {
    //                 maxlength: 6
    //             },
    //         },
    //     ],
    //     hideButtonsSection: false,
    //     hideIfCondition: (app) => {
    //         if(!app.hasOwnProperty('income_type') || app.income_type != 'other') {
    //             return true;
    //         }
    //         return false;
    //     }
    // },
    // new employment section
    {
        beforeCreate: function() {
            // console.log('beforeCreate');
        },
        beforeNextStep: function() {
            // console.log('beforeNextStep');
            // console.log('Fields validation and request to Portal/CMI');
        },
        title: "__employer_information__",
        // employment group questions
        fields: [
            {
                label: '__employer_name__',
                name: 'employer',
                placeholder: '',
                type: 'text',
                value: null,
                validationRules: 'required|max:50',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 50
                },
                hideIfHasValue: true,
            },
            {
                label: '__job_title__',
                name: 'job_title',
                placeholder: '',
                type: 'text',
                value: null,
                validationRules: 'required|max:50',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 50
                },
                hideIfHasValue: true,
            },
            // {
            //     label: '__phone_number_work__',
            //     name: 'phone_number_work',
            //     placeholder: '',
            //     type: 'text',
            //     value: null,
            //     validationRules: 'required|phone',
            //     fieldOuterClass: 'col-md-8 offset-md-2',
            //     attrs: {
            //         maxlength: 10
            //     },
            // },
        ],
        hideIfCondition: (app) => {
            return fieldConditionHelper.employment(app);
        }
    },
    {
        beforeCreate: function() {
            // console.log('beforeCreate');
        },
        beforeNextStep: function() {
            // console.log('beforeNextStep');
            // console.log('Fields validation and request to Portal/CMI');
        },
        title: "__employed_months__",
        // employment group questions
        fields: [
            {
                // label: 'Time At Job',
                name: 'employed_months',
                placeholder: '',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    { "text":"__opt_employed_months_3_less__", "value":"2" },
                    { "text":"__opt_employed_months_3_6__", "value":"6" },
                    { "text":"__opt_employed_months_6_12__", "value":"12" },
                    { "text":"__opt_employed_months_12_more__", "value":"15" },
                ],
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
        hideIfCondition: (app) => {
            return fieldConditionHelper.employment(app);
        }
    },
    // new employment section ENDS
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__address__",
        fields: [
            {
                // addressLabel: 'Your Address',
                name: 'address',
                placeholder: '',
                type: 'fulladdress',
                fieldOuterClass: 'col-md-8 offset-md-2',
                value: null,
                // validationRules: 'required',
            },
        ],
    },
    {
        beforeCreate: function() {
        },
        beforeNextStep: function() {
        },
        title: "__address_length_months__",
        fields: [
            {
                // label: 'Time At Address',
                name: 'address_length_months',
                placeholder: '',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    { "text":"__opt_address_length_months_3_less__", "value":"2" },
                    { "text":"__opt_address_length_months_3_6__", "value":"6" },
                    { "text":"__opt_address_length_months_6_12__", "value":"12" },
                    { "text":"__opt_address_length_months_12_more__", "value":"15" },
                ],
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
        // hideIfCondition: (app) => {
        //     var options = [
        //         'ON','BC','QC'
        //     ];
        //     return !app.address || !app.address.province || !options.includes(app.address.province);
        // }
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__own_home__",
        fields: [
            {
                name: 'own_home',
                placeholder: '',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    { "text":"__opt_yes__", "value":"yes" },
                    { "text":"__opt_no__", "value":"no" },
                ],
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
        hideIfCondition: (app) => {
            const options = [
                'ON','BC','QC'
            ];
            return !app.address || !app.address.province || !options.includes(app.address.province);
        }
    },
    rentMortgagePaymentStep({
        hideIfCondition: (app) => {
            const options = [
                'ON','BC','QC'
            ];
            return !app.address || !app.address.province || !options.includes(app.address.province);
        },
    }),
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__citizen_status__",
        fields: [
            {
                // label: 'Citizenship Status',
                name: 'canadian_status',
                placeholder: '',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    { "text":"__opt_cs_citizen__", "value":"citizen" },
                    { "text":"__opt_cs_permanent__", "value":"pr" },
                    { "text":"__opt_cs_work__", "value":"work_permit" },
                    { "text":"__opt_cs_student__", "value":"student_visa" },
                    { "text":"__opt_cs_visitor__", "value":"other" },
                    { "text":"__opt_cs_other__", "value":"other" },
                ],
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__dob__",
        fields: [
            {
                // label: 'What is your date of birth?',
                name: 'dob',
                placeholder: null,
                type: 'date',
                value: null,
                validationRules: 'required|dob',
                fieldOuterClass: 'col-md-6 offset-md-3',
                attrs: {
                    maxlength: 10
                },
                hideIfHasValue: true,
            },
        ],
    },
    {
        // beforeCreate: 'enablePartialRequestPerStep',
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__how_to_contact__",
        fields: [
            {
                label: '__first_name__',
                name: 'first_name',
                // placeholder: 'First Name',
                type: 'text',
                value: null,
                validationRules: 'required|name',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 50
                },
                hideIfHasValue: false,
            },
            {
                label: '__last_name__',
                name: 'last_name',
                // placeholder: 'Last Name',
                type: 'text',
                value: null,
                validationRules: 'required|name',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 50
                },
                hideIfHasValue: false,
            },
            {
                label: '__email_address__',
                name: 'email',
                // placeholder: '__your_email__',
                type: 'text',
                value: null,
                validationRules: 'required|email',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 50
                }
            },
            {
                label: '__phone_number__',
                name: 'phone_number',
                // placeholder: 'Your phone number',
                type: 'text',
                value: null,
                validationRules: 'required|canadianPhone',
                fieldOuterClass: 'col-md-8 offset-md-2',
                attrs: {
                    maxlength: 10
                },
                hideIfHasValue: false,
            },
            // {
            //     // label: 'Credit Auth',
            //     label: false,
            //     name: 'opt_in',
            //     placeholder: '',
            //     type: 'checkbox',
            //     value: null,
            //     // validationRules: 'required',
            //     // fieldOuterClass: 'col-md-10 offset-md-1',
            //     fieldInnerClass: 'large-checkbox',
            //     // choices: [
            //     //     { "text":'__opt_opt_in_consent__', "value":true },
            //     // ]
            //     choices: (app) => {
            //         if(app.projectBrandKey) {
            //             if(app.projectBrandKey == 'lc') {
            //                 return [
            //                     { "text":'__opt_opt_in_consent__', "value":true },
            //                 ];
            //             }
            //             else if(app.projectBrandKey == 'comparehub') {
            //                 return [
            //                     { "text":'__opt_opt_in_consent_by_lc__', "value":true },
            //                 ];
            //             }
            //         }
            //
            //         return [
            //             { "text":'__opt_opt_in_consent_by_comparehub__', "value":true },
            //         ];
            //     },
            // },
        ],
        // textBottom: '<p class="text-muted" style="font-size:14px;">By continuing with this form, you consent, acknowledge, and agree to our <a href="https://loanscanada.ca/privacy-policy" target="_blank">privacy policy</a> including your application data being shared with Loans Canada\'s partner(s) (see third-party vendor list <a href="https://loanscanada.ca/third-party-vendor-list/" target="_blank">here</a>), data stored outside of the province of Quebec, and Loans Canada and/or its other partners contacting you by phone, SMS (charges may apply depending on your carrier, not by us, messaging frequency varies; text HELP for help; text STOP to cancel) or e-mail to respond to (or request feedback from) your request. You can opt-out at any time.</p>'
        textBottomBelowActionButtons: '__credit_history_authorization_1_car_loan__'
    },
    {
        // loadingFunction: (app) => {
        //     return [
        //         {
        //             seconds: 4,
        //             message: '<h3 class="my-4 text-center h4 text-muted">Processing...</h3>'
        //         },
        //     ];
        // },
        beforeCreate: 'enablePartialRequestPerStep',
        beforeNextStep: function() {},
        // beforeCreate: function(app) {
        //     return !!app.verified_phone_number ? 'executeEarlySubmitApplication' : false;
        // },
        title: "__car_request_sms_verification_code__",
        fields: [
            {
                // label: 'SMS Verification',
                name: 'sms_verification',
                type: 'smsverification',
                value: null,
            },
        ],
        hideButtonsSection: true,
        nextButtonText: '__skip__',
        nextButtonClass: 'btn-secondary',
        hideIfCondition: (app) => {
            return !app.forceSmsVerification;
        }
    },
    {
        beforeCreate: function() {},
        beforeNextStep: function() {},
        title: "__direct_deposit__",
        fields: [
            {
                // label: 'Do you receive your income by direct deposit?',
                name: 'direct_deposit',
                placeholder: '',
                type: 'radio',
                value: null,
                validationRules: 'required',
                fieldOuterClass: 'col-md-8 offset-md-2',
                choices: [
                    { "text":"__opt_yes__", "value":"yes" },
                    { "text":"__opt_no__", "value":"no" },
                ],
                hideIfHasValue: true,
            },
        ],
        hideButtonsSection: true,
        hideIfCondition: (app) => {
            return true;
        }
    },
    {
        // beforeCreate: function() {
        // },
        // beforeNextStep: function() {
        // },
        beforeNextStep: function() {},
        title: "__flinks_powersports__",
        fields: [
            {
                // label: '',
                name: 'flinks_iframe',
                type: 'flinks',
                value: null,
            },
        ],
        textBottom: '__flinks_skip__',
        // hideButtonsSection: true,
        // hideIfCondition: (app) => {
        //     return fieldConditionHelper.employment(app);
        // }
        isStepSkippable: false,
        nextButtonText: '__skip__',
        nextButtonClass: 'btn-secondary'
    },
    // {
    //     beforeCreate: function() {},
    //     title: "This is the last step!",
    //     // textTop: `<p class="text-muted h5 my-3">Please fill out the form below to complete your loan application.</p>`,
    //     fields: [
    //         {
    //             label: 'Do you have a valid driver\'s license?',
    //             name: 'has_valid_drivers_license',
    //             placeholder: '',
    //             type: 'select',
    //             value: null,
    //             validationRules: 'required|driversLicense',
    //             choices: [
    //                 { "text":"No", "value":"no" },
    //                 { "text":"Yes", "value":"yes" },
    //             ],
    //         },
    //         {
    //             // label: 'Credit Auth',
    //             label: false,
    //             name: 'credit_auth',
    //             placeholder: '',
    //             type: 'checkbox',
    //             value: null,
    //             validationRules: 'required',
    //             choices: [
    //                 { "text":"I expressly allow the dealership and service providers of the dealership in the field of credit and loan services to collect, use, disclose and retain personal information about me for the purposes of facilitating the supply of financial credit scoring and options services through means that include profiling, automated recommendations and decision-making based on relevant factors regarding borrowers, and of continuously improving such means.<br><br>My consent is valid until I notify the dealership of its withdrawal, subject to legal or contractual restrictions and reasonable notice.", "value":true },
    //             ]
    //         },
    //         {
    //             // label: 'Opt In',
    //             label: false,
    //             name: 'opt_in',
    //             placeholder: '',
    //             type: 'checkbox',
    //             value: null,
    //             choices: [
    //                 { "text":"I would like to receive electronic messages from Loans Canada containing news, updates and promotions regarding its products and services, including third party promotions (you can withdraw your consent at any time). This request is made by Loans Canada, situated in 170-1201 University Ave, Toronto, ON, M5H 3B3. Email communications are sent via Loans Canada's mailing systems.", "value":true },
    //             ]
    //         },
    //     ],
    //     nextButtonText: 'Submit'
    //     // textBottom: (app) => {
    //     //     if(fieldConditionHelper.hasAuthConsent(app)) {
    //     //         return false;
    //     //     }
    //     //     return `<p class="text-muted my-3"><small>By continuing with this form, you consent, acknowledge, and agree to our <a href='https://loanscanada.ca/privacy-policy' target='_blank'>privacy policy</a> including your application data being shared with Loans Canada's partner(s) (see third-party vendor list <a href='https://loanscanada.ca/third-party-vendor-list/' target='_blank'>here</a>), data stored outside of the province of Quebec, and Loans Canada and/or its other partners contacting you by phone, SMS (charges may apply depending on your carrier, not by us, messaging frequency varies; text HELP for help; text STOP to cancel) or e-mail to respond to (or request feedback from) your request. You can opt-out at any time.</small></p>`;
    //     // },
    // },
];

export default steps;
